import { engagementModelsData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function EngagementModelsSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="container-astro">
        <AnimatedSection>
          <div className="text-center mb-14 md:mb-18">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 mb-5 font-heading tracking-tight">
              {engagementModelsData.heading}
            </h2>
            <div className="w-16 h-1 bg-accent-500 rounded-full mx-auto" />
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {engagementModelsData.items.map((item, i) => (
            <AnimatedSection key={item.title} delay={i * 150}>
              <div className="group p-7 md:p-8 rounded-2xl bg-background-50 border border-background-200/60 hover:border-accent-300/30 hover:shadow-lg hover:shadow-accent-500/5 transition-all duration-400 card-lift h-full flex flex-col">
                <div className="inline-flex items-center self-start px-3 py-1 rounded-full bg-accent-500/10 text-accent-600 text-[10px] font-bold uppercase tracking-wider mb-5">
                  {item.highlight}
                </div>

                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                </div>

                <h3 className="text-lg font-bold text-foreground-950 mb-2.5 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-grow">
                  {item.desc}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>

        <AnimatedSection delay={400}>
          <div className="text-center mt-12 md:mt-16">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316] text-white text-sm font-semibold rounded-xl hover:brightness-110 hover:-translate-y-0.5 transition-all duration-300 shadow-lg shadow-[#7C3AED]/25 whitespace-nowrap btn-arrow-hover group"
            >
              {engagementModelsData.cta}
              <i className="ri-arrow-right-line btn-arrow transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}